import { createPageStore } from 'common/store';
import { customActions } from './custom-actions';
import { INITIAL_STATE } from './constants';
export var useNotificationDrawerStore = createPageStore({
    initialValues: INITIAL_STATE,
    customActions: customActions,
});
